/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation, Autoplay, EffectFade, Pagination } from "swiper";
Swiper.use([Navigation, Autoplay, EffectFade, Pagination]);
import customEventsNames from './../customEventsNames';
export function slider() {
    const CardsSliderSelector = ".cards__list-wrapper.swiper"

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Cards slider
        const CardsSliders = [];
        const CardsSlidersElements = document.querySelectorAll(CardsSliderSelector);
        if (CardsSlidersElements) {
            CardsSlidersElements.forEach(slider => {

                CardsSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    },
                }));
            })
        }
    };

    init();
}
